<template>
  <div>
    <MulReportHeader
      :dataFrom="table.params"
      @search="searchData"
      :isRange="true"
      :excelShow="false"
      ref="handleRenHeader"
    ></MulReportHeader>
    <Tabs v-model="checkName" @on-click="tabChange()">
      <TabPane
        :label="item.title"
        :name="item.name"
        v-for="(item, index) in tabList"
        :key="index"
      ></TabPane>
    </Tabs>
    <Table
      border
      :columns="table.columns"
      :max-height="maxHeight"
      :data="table.data"
      @on-sort-change="sortChange"
    ></Table>
    <Modal v-model="imageData.show" width="1000">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ imageData.app_name }}</span>
      </p>
      <div>
        <Select
          class="select"
          v-model="imageData.checkColumn"
          style="width: 200px"
          @on-change="imageIndexChange"
        >
          <Option
            v-for="(item, index) in imageData.chartSettings.labelMap"
            :value="index"
            :key="index"
            :label="item"
          ></Option>
        </Select>
        <ve-line
          :data="imageData.chartData"
          :settings="getChartSetting()"
          :colors="imageData.options"
          :extend="imageData.extend"
          :ref="imageData.ref"
        ></ve-line>
      </div>
    </Modal>
  </div>
</template>

<script>
import MulReportHeader from '../Report/components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import publicTable from '@/views/components/publicTable.vue'
import moment from 'moment'
export default {
  name: 'HandleRenData',
  components: { MulReportHeader, publicTable },
  data() {
    return {
      maxHeight: 0,
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      checkName: '0',
      tabList: [
        {
          name: '0',
          title: '新增转入留存',
          request: ['GetNewPlatfromNewPayInfo', 'GetUserRetainData']
        },
        { name: 'GetNewPlatformRepeatPayInfo', title: '转入留存' },
        { name: 'GetNewPlatfromFistPayData', title: '首充留存' }
      ],
      imageData: {
        show: false,
        app_name: '',
        ref: 'renChartImage',
        checkColumn: 'new_user_num',
        options: ['#32CD32', 'rgb(244, 128, 36)'],
        extend: { series: { smooth: false } },
        chartSettings: {
          labelMap: {
            new_user_num: '新增人数',
            new_user_pay_num: '新增转入人数',
            zhuan_rate: '新增转化率',
            pay_user_num: '转入人数',
            first_pay_num: '首充人数',
            ci_ri_pay_rate: '次日转入复充率',
            ci_ri_login_rate: '次日复充登录率',
            ci_ri_bet_rate: '次日复充投注率',
            three_pay_rate: '3日转入复充率',
            three_login_rate: '3日复充登录率',
            three_bet_rate: '3日复充投注率',
            seven_pay_rate: '7日转入复充率',
            seven_login_rate: '7日复充登录率',
            seven_bet_rate: '7日复充投注率',
            online_rate: '线上转入成功率'
          },
          yAxisType: ['percent']
        },
        chartData: {
          columns: ['time', 'new_user_num'],
          rows: []
        }
      },
      tableTotal: this.getTableTotal(),
      table: {
        params: {
          platids: [],
          app_ids: [],
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay()
          ]
        },
        data: [],
        columns1: this.getColumn(false),
        columns: this.getColumn(true)
      }
    }
  },
  mounted () {
    this.maxHeight = window.document.body.clientHeight - 250
  },
  methods: {
    getColumn(isExpand) {
      return [
        isExpand
          ? {
              type: 'expand',
              width: 40,
              align: 'center',
              render: (h, params) => {
                return h(publicTable, {
                  props: {
                    row: params.row.data,
                    columns: this.table.columns1
                  }
                })
              }
            }
          : {
              align: 'center',
              width: 40,
              render: (h, params) => {
                return h('span', '')
              }
            },
        {
          key: 'app_name',
          width: 70,
          resize: true,
          align: 'center',
          renderHeader: h => this.renderHeader(h, '平台名称', '查询盘口名称')
        },
        {
          key: 'plat_name',
          width: 70,
          resize: true,
          align: 'center',
          renderHeader: h =>
            this.renderHeader(h, '所属分组', '查询盘口所在分组')
        },
        this.renderBaseCol(
          'new_user_num',
          '新增人数',
          '盘口筛选时间内的新增注册人数'
        ),
        this.renderBaseCol(
          'new_user_pay_num',
          '新增转入人数',
          '盘口筛选时间内的新增注册并完成转入的人数',
          100
        ),
        this.renderRateCol(
          'zhuan_rate',
          '新增转化率',
          '筛选时间内,盘口新增转入人数 / 新增人数',
          100
        ),
        this.renderBaseCol(
          'pay_user_num',
          '转入人数',
          '盘口筛选时间内的转入的人数；'
        ),
        this.renderBaseCol(
          'first_pay_num',
          '首充人数',
          '盘口筛选时间内的历史第一次完成转入的人数；'
        ),
        this.renderFTSCol(
          'ci_ri_pay_rate',
          '次日转入复充率',
          '首天转入，次日也完成转入的人数/首天转入人数',
          0
        ),
        this.renderFTSCol(
          'ci_ri_login_rate',
          '次日复充登录率',
          '首天转入，次日登录游戏的人数/首天转入人数',
          0
        ),
        this.renderFTSCol(
          'ci_ri_bet_rate',
          '次日复充投注率',
          '首天转入，次日投注游戏的人数/首天充转入人数',
          0
        ),
        this.renderFTSCol(
          'three_pay_rate',
          '3日转入复充率',
          '首天转入，第3日也完成转入的人数/首天转入人数',
          1
        ),
        this.renderFTSCol(
          'three_login_rate',
          '3日复充登录率',
          '首天转入，第3日登录游戏的人数/首天转入人数',
          1
        ),
        this.renderFTSCol(
          'three_bet_rate',
          '3日复充投注率',
          '首天转入，第3日投注游戏的人数/首天充转入人数',
          1
        ),
        this.renderFTSCol(
          'seven_pay_rate',
          '7日转入复充率',
          '首天转入，第7日也完成转入的人数/首天转入人数',
          2
        ),
        this.renderFTSCol(
          'seven_login_rate',
          '7日复充登录率',
          '首天转入，第7日登录游戏的人数/首天转入人数',
          2
        ),
        this.renderFTSCol(
          'seven_bet_rate',
          '7日复充投注率',
          '首天转入，第7日投注游戏的人数/首天充转入人数',
          2
        ),
        // this.renderRateCol('online_rate', '线上转入成功率', '筛选时间内，线上完成转入订单/线上提交转入订单'),
        isExpand
          ? {
              title: '趋势图',
              align: 'center',
              minWidth: 80,
              render: (h, params) => {
                return h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'primary',
                      disabled: !params.row.data
                    },
                    on: {
                      click: () => {
                        this.getImageData(params.row)
                      }
                    }
                  },
                  '趋势图'
                )
              }
            }
          : { title: '趋势图', align: 'center', minWidth: 80 }
      ]
    },
    renderRateCol(key, title, tip, width = 110) {
      return {
        key,
        width,
        align: 'center',
        sortable: 'custom',
        resize: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) =>
          h('span', (params.row[key] * 100 || 0).toFixed(2) + '%')
      }
    },
    renderBaseCol(key, title, tip, width = 80) {
      return {
        key,
        width,
        align: 'center',
        sortable: 'custom',
        resize: true,
        renderHeader: h => this.renderHeader(h, title, tip)
      }
    },
    renderFTSCol(key, title, tip, index) {
      let arr = ['rgb(156,10,10)', 'rgb(62,64,253)', 'rgb(255,153,1)']
      return {
        key,
        width: 115,
        align: 'center',
        sortable: 'custom',
        resize: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) =>
          h(
            'span',
            { style: { color: arr[index] } },
            (params.row[key] * 100 || 0).toFixed(2) + '%'
          )
      }
    },
    //获取趋势图数据
    getImageData(param) {
      let rows = []
      if (param.data) {
        rows = this.copyData(param.data)
        rows.reverse()
      }
      rows.forEach(el => {
        el.time = moment(el.itime * 1000)
          .locale('zh-cn')
          .format('YYYY-MM-DD')
        console.log('el.time: ', el.time)
        for (let i in el) {
          if (i.includes('_sum') || i == 'pay_ave') {
            el[i] = this.getCustomFixed(el[i] / 10000)
          }
          if (i == 'bet_pay_rate') {
            el[i] = el[i] ? el[i].toFixed(2) : 0
          }
        }
      })
      let findType = this.tabList.find(el => el.name == this.checkName)
      this.imageData.chartData.rows = rows
      this.imageData.show = true
      this.imageData.app_name = param.app_name + ` (${findType.title})`
      this.$nextTick(() => {
        this.$refs[this.imageData.ref].echarts.resize()
      })
    },
    tabChange() {
      this.$refs.handleRenHeader.handleClick()
    },
    //变化时变更配置
    getChartSetting() {
      if (this.imageData.checkColumn.includes('_rate')) {
        return this.imageData.chartSettings
      } else {
        return Object.assign({}, this.imageData.chartSettings, {
          yAxisType: ['normal']
        })
      }
    },
    //更改趋势图显示的字段
    imageIndexChange(val) {
      this.imageData.chartData.columns = [
        this.imageData.chartData.columns[0],
        val
      ]
      this.$refs[this.imageData.ref].echarts.resize()
    },
    //查询数据
    searchData(emitProps) {
      let allList = this.getAllHttpAppid(this.table.params)
      let httpList = []
      let loadingArr = [...allList]
      let stime = this.getSecond(this.table.params.dataTime[0])
      let etime = this.getSecond(this.table.params.dataTime[1], false)
      this.timestamp = new Date().getTime() //设置请求时间
      this.table.data = []
      for (let i = 0, len = allList.length; i < len; i++) {
        let app_id = allList[i]
        let app_name = ''
        let platid = 0
        let plat_name = ''
        let item = emitProps.app_list.find(el => el.appid == app_id)
        if (item) {
          app_name = item.appName
          platid = item.platform
          plat_name = emitProps.plat_list.find(el => el.id == platid).name
        }
        let el = { platid, app_id, app_name }
        let param = this.getTransTopParams('GetNewPlatfromData', {
          platid,
          app_id,
          app_name,
          plat_name,
          stime,
          etime,
          general: -1,
          pack_no: -1,
          page: 1,
          limit: 10000,
          sort: 0,
          timestamp: this.timestamp
        })
        httpList.push(param)
      }
      this.tableTotal = this.getTableTotal()
      this.table.data = []
      let max = Math.min(5, httpList.length)
      for (let i = 0; i < max; i++) {
        this.toHttp(httpList, loadingArr)
      }
    },
    async toHttp(httpList, loadingArr) {
      if (httpList.length > 0) {
        let param = httpList.shift()
        if (this.isCurrentHttp(param.timestamp)) {
          this.openTimer()
          let canNext = true
          //请求平台数据
          let res = await TransTopReq(param)
          canNext = this.isCurrentHttp(param.timestamp) && !!res._param
          if (canNext) {
            let param1 = this.copyData(param)
            let param2
            if (this.checkName != '0') {
              param1.param._func = this.checkName
            } else {
              param1.param._func = this.tabList[0].request[0]
              param2 = this.copyData(param1)
              param2.param._func = this.tabList[0].request[1]
            }
            let res1 = await TransTopReq(param1)
            let res2
            if (param2) {
              res2 = await TransTopReq(param2)
              if (res1._param.data && res2._param.data) {
                res1._param.data.forEach(item => {
                  let find =
                    res2._param.data.find(el => el.time == item.time) || {}
                  item.ci_ri_login_num = find.one_retain_num || 0
                  item.ci_ri_login_rate = find.one_retain || 0
                  item.three_login_num = find.three_retain_num || 0
                  item.three_login_rate = find.three_retain || 0
                  item.seven_login_num = find.seven_retain_num || 0
                  item.seven_login_rate = find.seven_retain || 0
                  item.ci_ri_bet_rate = find.ci_ri_bet_rate || 0
                  item.ci_ri_bet_num = find.ci_ri_bet_num || 0
                  item.three_bet_rate = find.three_bet_rate || 0
                  item.three_bet_num = find.three_bet_num || 0
                  item.seven_bet_rate = find.seven_bet_rate || 0
                  item.seven_bet_num = find.seven_bet_num || 0
                })
              }
            }
            canNext = this.isCurrentHttp(param.timestamp) && res1._param
            if (canNext) {
              let data = res._param.data
              let data1 = res1._param.data
              res._param.plat_name = param.plat_name
              res._param.app_name = param.app_name
              // res._param.new_user_pay_num = 0;
              // res._param.first_pay_num = 0;
              // res._param.user_pay_num = 0;
              // res._param.ci_ri_pay_num = 0;
              // res._param.ci_ri_bet_num = 0;
              // res._param.ci_ri_login_num = 0;
              // res._param.three_pay_num = 0;
              // res._param.three_bet_num = 0;
              // res._param.three_login_num = 0;
              // res._param.seven_pay_num = 0;
              // res._param.seven_bet_num = 0;
              // res._param.seven_login_num = 0;
              // res._param.other_pay_num = 0;
              for (let key in res._param) {
                if (
                  key.includes('_num') ||
                  key.includes('rate') ||
                  key.includes('_sum') ||
                  key.includes('_point')
                ) {
                  res._param[key] = 0
                }
              }
              data.forEach(item => {
                if (item.time) {
                  item.online_rate = item.online_pay_all_num
                    ? item.online_pay_success_num / item.online_pay_all_num
                    : 0
                  item.app_name = moment(item.time).format('YYYY-MM-DD')
                  let time = item.app_name.replace(/\-/g, '')
                  let find =
                    data1.find(
                      el => el.time && el.time.replace(/\-/g, '') == time
                    ) || {}
                  item.ci_ri_pay_rate =
                    find.one_pay_rate || find.ci_ri_pay_rate || 0
                  item.ci_ri_login_rate =
                    find.one_login_rate || find.ci_ri_login_rate || 0
                  item.ci_ri_bet_rate =
                    find.one_bet_rate || find.ci_ri_bet_rate || 0
                  item.three_pay_rate = find.three_pay_rate || 0
                  item.three_login_rate = find.three_login_rate || 0
                  item.three_bet_rate = find.three_bet_rate || 0
                  item.seven_pay_rate = find.seven_pay_rate || 0
                  item.seven_login_rate = find.seven_login_rate || 0
                  item.seven_bet_rate = find.seven_bet_rate || 0
                  item.other_pay_num =
                    find.new_num || find.new_user_num || find.user_pay_num || 0
                  item.ci_ri_pay_num =
                    find.one_pay_num || find.ci_ri_pay_num || 0
                  item.ci_ri_bet_num =
                    find.one_bet_num || find.ci_ri_bet_num || 0
                  item.ci_ri_login_num =
                    find.one_login_num || find.ci_ri_login_num || 0
                  item.three_pay_num = find.three_pay_num || 0
                  item.three_bet_num = find.three_bet_num || 0
                  item.three_login_num = find.three_login_num || 0
                  item.seven_pay_num = find.seven_pay_num || 0
                  item.seven_bet_num = find.seven_bet_num || 0
                  item.seven_login_num = find.seven_login_num || 0

                  // res._param.new_user_pay_num += item.new_user_pay_num || 0;
                  // res._param.first_pay_num += item.first_pay_num || 0;
                  this.addItemOrAll(item, res._param)
                  let allItem = this.tableTotal.data.find(
                    el => el.app_name == item.app_name
                  )
                  if (allItem) {
                    // allItem.new_user_num += item.new_user_num;
                    // allItem.new_user_pay_num +=  item.new_user_pay_num;
                    // allItem.zhuan_rate = allItem.new_user_num ? allItem.new_user_pay_num /allItem.new_user_num : 0;
                    // allItem.pay_user_num += item.pay_user_num;
                    // allItem.first_pay_num +=  res._param.first_pay_num;
                    this.addItemOrAll(item, allItem)
                    this.calcReply(allItem)
                  } else {
                    this.tableTotal.data.push(this.copyData(item))
                  }
                }
              })
              let total = this.getTableTotal()
              total.data = this.tableTotal.data
              for (let i in total.data) {
                this.addItemOrAll(total.data[i], total)
              }
              Object.assign(this.tableTotal, total)
              this.calcReply(res._param)
              // this.tableTotal.new_user_num += res._param.new_user_num;
              // this.tableTotal.new_user_pay_num +=  res._param.new_user_pay_num;
              // this.tableTotal.zhuan_rate = this.tableTotal.new_user_num ? this.tableTotal.new_user_pay_num /this.tableTotal.new_user_num : 0;
              // this.tableTotal.pay_user_num += res._param.pay_user_num;
              // this.tableTotal.first_pay_num +=  res._param.first_pay_num;
              this.calcReply(this.tableTotal)
              this.table.data.pop()
              this.table.data.push(res._param)
              this.table.data.push(this.tableTotal)
              this.toHttp(httpList, loadingArr)
            }
          }
        }
      }
    },
    calcReply(target) {
      if (!target.data) {
        target.zhuan_rate = this.calcRate(
          target.new_user_pay_num,
          target.new_user_num
        )
        target.online_rate = this.calcRate(
          target.online_pay_success_num,
          target.online_pay_all_num
        )
        target.ci_ri_pay_rate = this.calcRate(
          target.ci_ri_pay_num,
          target.other_pay_num
        )
        target.ci_ri_login_rate = this.calcRate(
          target.ci_ri_login_num,
          target.other_pay_num
        )
        target.ci_ri_bet_rate = this.calcRate(
          target.ci_ri_bet_num,
          target.other_pay_num
        )
        target.three_pay_rate = this.calcRate(
          target.three_pay_num,
          target.other_pay_num
        )
        target.three_login_rate = this.calcRate(
          target.three_login_num,
          target.other_pay_num
        )
        target.three_bet_rate = this.calcRate(
          target.three_bet_num,
          target.other_pay_num
        )
        target.seven_pay_rate = this.calcRate(
          target.seven_pay_num,
          target.other_pay_num
        )
        target.seven_login_rate = this.calcRate(
          target.seven_login_num,
          target.other_pay_num
        )
        target.seven_bet_rate = this.calcRate(
          target.seven_bet_num,
          target.other_pay_num
        )
      } else {
        let len = target.data.length
        target.zhuan_rate = target.zhuan_rate / len
        target.online_rate = target.online_rate / len
        target.ci_ri_pay_rate = target.ci_ri_pay_rate / len
        target.ci_ri_login_rate = target.ci_ri_login_rate / len
        target.ci_ri_bet_rate = target.ci_ri_bet_rate / len
        target.three_pay_rate = target.three_pay_rate / len
        target.three_login_rate = target.three_login_rate / len
        target.three_bet_rate = target.three_bet_rate / len
        target.seven_pay_rate = target.seven_pay_rate / len
        target.seven_login_rate = target.seven_login_rate / len
        target.seven_bet_rate = target.seven_bet_rate / len
      }
    },
    addItemOrAll(from, to) {
      for (let key in from) {
        if (
          key.includes('_num') ||
          key.includes('rate') ||
          key.includes('_sum') ||
          key.includes('_point')
        ) {
          to[key] = to[key] || 0
          to[key] += from[key]
        }
      }
      // to.other_pay_num += from.new_user_num || from.user_pay_num || from.new_num || 0;
      // to.ci_ri_pay_num += from.ci_ri_pay_num || from.one_pay_num || 0;
      // to.ci_ri_bet_num += from.ci_ri_bet_num || from.one_bet_num || 0;
      // to.ci_ri_login_num += from.ci_ri_login_num || from.one_login_num || 0;
      // to.three_pay_num += from.three_pay_num || 0;
      // to.three_bet_num += from.three_bet_num || 0;
      // to.three_login_num += from.three_login_num || 0;
      // to.seven_pay_num += from.seven_pay_num || 0;
      // to.seven_bet_num += from.seven_bet_num || 0;
      // to.seven_login_num += from.seven_login_num || 0;
    },
    getTableTotal() {
      return {
        app_id: -10,
        app_name: '合计',
        plat_name: '',
        new_user_num: 0,
        new_user_pay_num: 0,
        zhuan_rate: 0,
        pay_user_num: 0,
        first_pay_num: 0,
        online_pay_rate: 0,
        online_pay_success_num: 0,
        online_pay_all_num: 0,
        ci_ri_pay_rate: 0,
        ci_ri_pay_num: 0,
        user_pay_num: 0,
        ci_ri_bet_num: 0,
        ci_ri_login_num: 0,
        three_pay_num: 0,
        three_bet_num: 0,
        three_login_num: 0,
        seven_pay_num: 0,
        seven_bet_num: 0,
        seven_login_num: 0,
        other_pay_num: 0,
        data: []
      }
    },
    //关闭定时器
    closeTimer() {
      this.loading = false
      clearTimeout(this.TransTopReqTimer)
      this.TransTopReqTimer = null
    },
    //批量请求开启定时器8秒超时
    openTimer() {
      this.closeTimer()
      this.loading = true
      this.TransTopReqTimer = setTimeout(() => {
        this.loading = false
      }, 6000)
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: param.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        plat_name: param.plat_name,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: { ...param }
        }
      }
    },

    sortChange(params) {
      let find = this.table.data.find(el => el._expanded)
      if (find) find._expanded = false
      let order = params.order == 'desc' ? 1 : -1
      let key = params.key
      this.table.data.sort((a, b) => {
        if (a.app_id == -10) return 1
        if (b.app_id == -10) return -1
        return a[key] * order > b[key] * order ? -1 : 1
      })
    },

    isCurrentHttp(timestamp) {
      return timestamp == this.timestamp
    }
  }
}
</script>

<style scoped lang="less"></style>
